import { useState, useEffect } from 'react';
export const useKeyPress = (targetKeys) => {
    const [pressedKey, setPressedKey] = useState('');

    const downHandler = ({ key }) => {
        if (targetKeys.includes(key.toUpperCase())) {
            setPressedKey(key.toUpperCase());
        }
    };

    const resetPressedKey = () => setPressedKey('');
    useEffect(() => {
        window.addEventListener('keydown', downHandler);
        return () => {
            window.removeEventListener('keydown', downHandler);
        };
    });

    return { pressedKey, resetPressedKey };
};
